module.exports = __webpack_public_path__ + "img/name.3aa00324.png";